import {
  __name,
  __spreadValues
} from "./chunk-DVUTYNGK.jsx";

// src/utils/units/units.ts
var getIntlUnit = /* @__PURE__ */ __name(({ lang, number, options }) => new Intl.NumberFormat(lang, __spreadValues({
  style: "unit"
}, options)).format(number), "getIntlUnit");

export {
  getIntlUnit
};
